import React, { Component } from "react";
import BasicLayout from "../../Layout/BasicLayout";
import TopFeature from "../../Section/Homepage/topFeature";
import HeaderLayer from "../Constants/HeaderLayer";
import "./index.css";
class Panel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rate: false,
    };
  }
  render() {
    const togglerate = () => {
      this.setState({ rate: true });
    };
    return (
      <BasicLayout>
        <HeaderLayer
          title={this.props.title}
          detail={this.props.detail}
          backimage={this.props.backimage}
        >
          <TopFeature togglerate={togglerate} />
        </HeaderLayer>

        {this.state.rate ? <div>{this.props.children}</div> : ""}
      </BasicLayout>
    );
  }
}

export default Panel;
